import api from './api';
import types from './mutation-types';

export default {
	fetchTasks_: ({ commit, state }, payload) => {
		return api
			.fetchTasks(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'tasks',
						value: resultList
					});
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	saveTasks_: ({ commit, state }, payload) => {
		return api
			.saveTasks(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deleteTasks_: ({ commit, state }, payload) => {
		return api
			.deleteTasks(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchTaskScript_({ state, commit }, payload) {
		return api
			.fetchTaskScript(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					const { compileCd } = body;
					state.codemirror.doc.setValue(compileCd);
				} else if (code === 3) {
					throw new Error(message);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	updateTaskScript_: ({ commit, state }, payload) => {
		return api
			.updateTaskScript(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
